<script>
export default {
  name: "CompanyList",
  props: {
    companies: Array,
    currentPage: Number,
    total: Number,
    activityTypes: Array,
    titleSearch: {
      type: String,
      default: "",
    },
    routePrefix: {
      type: String,
      default: "companies",
    },
    filterCategoryId: {
      default: null,
    },
    filterStatus: {
      default: null,
    },
    companyBuildStatusNumber: {
      type: Number,
      default: 0,
    },
    statusBuild: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      companiesFields: [
        {key: "title", label: "Наименование компании", class: "th-title align-middle"},
        {key: "guid", label: "Идентификатор компании", class: "guid align-middle"},
        {key: "activity_type", label: "Вид деятельности", class: "activity_type align-middle"},
        {key: "actions", label: "Действия", class: "actions align-middle text-center"},
      ],
      expositionFields: [
        {key: "title", label: "Наименование стенда", class: "th-title align-middle"},
        {key: "guid", label: "Идентификатор стенда", class: "guid align-middle"},
        {key: "actions", label: "Действия", class: "actions align-middle text-center"},
      ],

      filter: {
        category_id: null,
        status: null,
        prefix: null,
      },

      items: {
        companyNoPlaces: null,
        companies: [],
        category: [],
        companyAll: null,
        companyModify: null,
      },
      option: {
        category: [
          {
            id: null,
            title: "Все залы",
          },
        ],
      },

      text: "",
      boxOne: "",
      boxTwo: "",
      loading: true,
      LocalCompanyBuildStatusNumber: 0,
    }
  },
  watch: {
    filter: {
      handler: function () {
        let url
        if (this.routePrefix === "companies") {
          url = `/companies/list/?title=${this.text}`
        } else {
          url = `/exposition/manage/?title=${this.text}`
        }
        let redirect = false
        url += "&category_id=" + this.filter.category_id
        if (this.filter.category_id !== this.filterCategoryId) {
          redirect = true
        }
        url += "&status=" + this.filter.status
        if (this.filter.status !== this.filterStatus) {
          redirect = true
        }
        if (redirect) {
          window.location = url
        }
      },
      deep: true,
    },
  },
  created() {
    this.items.category = _.sortBy(this.activityTypes, "Name")
    // this.items.category = _.sortBy(_.filter(this.activityTypes, "View"), "Name")
    this.filter.category_id = this.filterCategoryId
    this.filter.status = this.filterStatus
    this.text = this.titleSearch
    // this.companyBuild = this.companyBuild
    this.items.companies = this.companies
  },
  methods: {
    copyDeepLink(item) {
      navigator.clipboard
        .writeText(`https://admin.vrktpp.ru/business/card/${item.guid}`)
        .then(() => {
          this.makeToast("Ссылка скопирована", "success")
        })
        .catch((err) => {
          this.makeToast("Ошибка при копировании", "danger")
        })
    },
    selectCategory(item) {
      this.filter.category_id = item.id
    },
    selectStatus(status) {
      this.filter.status = status
    },
    makeToast(body = "Ничего не произошло", variant = "success", title = "Уведомление") {
      this.$bvToast.toast(body, {
        title: title,
        autoHideDelay: 9000,
        appendToast: false,
        variant: variant,
        toaster: "b-toaster-bottom-center",
      })
    },
    getActiveTypeById(id) {
      return id === "" || id === null
        ? {
          Id: "",
          Name: "Без вида деятельности",
          View: false,
        }
        : _.find(this.getActivityTypes, (item) => {
          // noinspection JSUnresolvedVariable,EqualityComparisonWithCoercionJS
          return item.Id == id
        })
    },
    getActiveTypeNameById(id) {
      const activeType = this.getActiveTypeById(id)
      return activeType.Name
    },
    companyDelete(guid) {
      this.boxTwo = ""
      this.$bvModal
        .msgBoxConfirm("Действительно удалить компанию?", {
          title: "Подтверждение удаления компании",
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Удалить",
          cancelTitle: "Отменить",
          hideHeaderClose: true,
          centered: true,
          bodyClass: "h5",
          titleClass: "font-weight-bold",
          headerClass: "border-bottom-0",
          footerClass: "border-top-0",
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            window.location = `/${this.routePrefix}/${guid}/delete`
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
    companyBuild(isStart = 0) {
      this.items.companyNoPlaces = null
      this.$bvModal.show("modal-company-build")
      axios
        .get("/webapi/company/activate", {
          params: {
            isStart,
          },
        })
        .then(({data}) => {
          // handle success
          this.items.companyAll = data.meta.all
          this.items.companyModify = data.meta.modify
          if (data.data === "success") {
            this.LocalCompanyBuildStatusNumber = 2
            this.$bvModal.hide("modal-company-build")
            this.makeToast("Сборка активирована", "success")
          } else {
            this.items.companyNoPlaces = data.data
          }
        })
        .catch(function (error) {
          // handle error
          this.items.companyNoPlaces = []
          console.log(error)
        })
        .then(function () {
          // always executed
        })
    },
    companyUpdateStatus(guid, status) {
      this.boxTwo = ""
      let text_1 = ""
      let text_2 = ""
      let text_3 = ""
      let url = ""
      if (status === "activate") {
        text_1 = "активации"
        text_2 = "активировать"
        text_3 = "Активировать"
        url = `/${this.routePrefix}/${guid}/activated`
      } else {
        text_1 = "деактивации"
        text_2 = "деактивировать"
        text_3 = "Деактивировать"
        url = `/${this.routePrefix}/${guid}/deactivated`
      }

      this.$bvModal
        .msgBoxConfirm(`Действительно ${text_2} компанию?`, {
          title: `Подтверждение ${text_1} компании`,
          size: "md",
          buttonSize: "md",
          okVariant: "primary",
          cancelVariant: "secondary",
          okTitle: text_3,
          cancelTitle: "Отменить",
          hideHeaderClose: true,
          centered: true,
          bodyClass: "h5",
          titleClass: "font-weight-bold",
          headerClass: "border-bottom-0",
          footerClass: "border-top-0",
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            window.location = url
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
  },
  computed: {
    getActivityTypes() {
      return _.sortBy(_.filter(this.activityTypes, "View"), "Name")
    },
    isCompanyBuild() {
      return this.statusBuild === 1 || this.companyBuildStatusNumber === 2 || this.LocalCompanyBuildStatusNumber === 2
    },
    getCompanyNoPlaces() {
      return this.items.companyNoPlaces
    },
    getCompanies() {
      return this.items.companies
    },
    loadingModalCompanyBuild() {
      return this.items.companyNoPlaces === null
    },
    currentCategory() {
      const category = this.optionCategory.find((item) => item.id === this.filter.category_id)
      return category ? category : {title: "Все залы"}
    },
    currentStatus() {
      let status = "Все статусы"
      if (this.filter.status === "true" || this.filter.status === true) {
        status = "Активные"
      }
      if (this.filter.status === "false" || this.filter.status === false) {
        status = "Не активные"
      }
      return status
    },
    optionCategory() {
      const categories = this.items.category
        .filter((item) => {
          return item.View
        })
        .map((item) => {
          return {
            id: item.Id,
            title: item.Name,
          }
        })
      return this.option.category.concat(categories)
    },
  },
}
</script>

<style>
th.actions {
  width: 240px;
}

th.th-title {
  text-align: center;
}

th.guid {
  min-width: 210px;
  text-align: center;
}

th.activity_type {
  min-width: 160px;
  text-align: center;
}

.dropdown-menu {
  max-height: 400px;
  overflow-y: auto;
}
</style>
